import { useRef } from "react";

const STORAGE_KEY = "weco:last-login";

export function getLastLoginTimestamp(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}
export function setLastLoginTimestamp(iso: string): void {
  localStorage.setItem(STORAGE_KEY, iso);
}

// Captured once per app load, before any consumer reads it, so every consumer
// (useHomeDashboard, the Mochi welcome trigger) sees the SAME previous login.
let _previous: string | null | undefined;
export function getPreviousLogin(): string | null {
  if (_previous === undefined) {
    _previous = getLastLoginTimestamp();
    setLastLoginTimestamp(new Date().toISOString());
  }
  return _previous;
}

/** Returns the previous login timestamp (captured once, app-wide). */
export function useLastLogin(): string | null {
  const ref = useRef<string | null>(null);
  ref.current = getPreviousLogin();
  return ref.current;
}
